import { Dialog } from '~/components/Dialog';
import type { ModalCloseReason } from '~/components/StandardModal/types';

export const authInputClassName =
  'h-12 w-full rounded-lg border border-grey-divide bg-white p-4 font-body text-base placeholder:text-grey-hide focus:border-black focus:outline-none focus:placeholder:text-transparent';

export const authButtonClassName =
  'flex h-12 w-full items-center justify-center gap-2';

type Props = {
  children: React.ReactNode;
  onDismiss: (reason: ModalCloseReason) => void;
};

export default function AuthDialog({ children, onDismiss }: Props) {
  return (
    <Dialog
      isOpen={true}
      onDismiss={onDismiss}
      className="z-50 flex flex-col items-center gap-4 rounded-2xl bg-white px-4 py-8 text-black shadow-md focus:outline-none max-sm:w-[calc(100%-2rem)] sm:w-[456px] md:px-6 lg:w-[552px]"
    >
      {children}
    </Dialog>
  );
}
